import { render, staticRenderFns } from "./VxCard.vue?vue&type=template&id=1c85b83a"
import script from "./VxCard.vue?vue&type=script&lang=js"
export * from "./VxCard.vue?vue&type=script&lang=js"
import style0 from "./VxCard.vue?vue&type=style&index=0&id=1c85b83a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c85b83a')) {
      api.createRecord('1c85b83a', component.options)
    } else {
      api.reload('1c85b83a', component.options)
    }
    module.hot.accept("./VxCard.vue?vue&type=template&id=1c85b83a", function () {
      api.rerender('1c85b83a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/theme/VxCard.vue"
export default component.exports